// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__263YX","colMaxWidth":"Table_colMaxWidth__1XcIR"};